"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricaNo = void 0;
var bson_1 = require("bson");
var FabricaNo = /** @class */ (function () {
    function FabricaNo(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.CD_FABRICA, CD_FABRICA = _c === void 0 ? '' : _c, _d = _a.NODE, NODE = _d === void 0 ? '' : _d, _e = _a.DT_VAL_INI, DT_VAL_INI = _e === void 0 ? '' : _e, _f = _a.DT_VAL_FIM, DT_VAL_FIM = _f === void 0 ? '' : _f, _g = _a.CAPACIDADE, CAPACIDADE = _g === void 0 ? 0 : _g;
        this._id = _id;
        this.CD_FABRICA = CD_FABRICA;
        this.NODE = NODE;
        this.DT_VAL_INI = DT_VAL_INI;
        this.DT_VAL_FIM = DT_VAL_FIM;
        this.CAPACIDADE = CAPACIDADE;
    }
    return FabricaNo;
}());
exports.FabricaNo = FabricaNo;
//# sourceMappingURL=FabricaNo.js.map